import { $apiV1 } from "../config/api";

// The user profile (settings, offsets, flags) is static for a session and the
// backend already caches it for 24h. It was being re-fetched from many places
// (per video player, per window focus, per video extend, per page) — flooding
// the API with identical GET /users/user_profile calls.
//
// This memoises the request: concurrent callers share one in-flight promise and
// subsequent callers reuse the resolved one. Any code that WRITES profile
// settings (PATCH /users/profile_settings) must call invalidateUserProfile()
// so the next read refetches fresh data.
let userProfilePromise = null;

/**
 * Fetch the current user's profile, deduped + cached for the session.
 * Returns the axios response (callers read `res.data`), matching the old
 * `$apiV1.get('/users/user_profile')` shape.
 *
 * @param {boolean} force  Bypass the cache and refetch (e.g. on window focus).
 */
export function getUserProfile(force = false) {
  if (force) {
    userProfilePromise = null;
  }

  if (!userProfilePromise) {
    userProfilePromise = $apiV1.get("/users/user_profile").catch((error) => {
      // Never cache a failed request — let the next caller retry.
      userProfilePromise = null;
      throw error;
    });
  }

  return userProfilePromise;
}

/** Drop the cached profile so the next getUserProfile() refetches. */
export function invalidateUserProfile() {
  userProfilePromise = null;
}
